import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MainRouteView.html?raw';
import { TiClassNames, TiEntities, TiInterfaces } from "../TiTypes";
import TiRouteSectionsView from './RouteSectionView';

class TiMainRouteView extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private mainContainer: HTMLElement;

    private mainRouteSlot: TiEntities.MainRouteTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension;
    private routeSectionSlots: Array<TiEntities.SectionTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension>;


    private config: TiInterfaces.TiMainRouteViewConfig = null;

    loadMainRouteById(mainRouteSlotID: string, config?: TiInterfaces.TiMainRouteViewConfig) {
        if (!mainRouteSlotID) return;

        if (config) this.setConfig(config);

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TransportIntermodal__LoadMainRouteSlot",
            {
                "mainRouteSlotID": mainRouteSlotID
            },
            lang.hitch(this, this._onLoadMainRouteSlot),
            lang.hitch(this, this._onLoadMainRouteSlotError)
        );

    }

    private _onLoadMainRouteSlot(response: TiEntities.MainRouteTimeSlotEntity_Aliased) {
        this.StandbyStop();

        this.setData(response);
    }

    private _onLoadMainRouteSlotError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    setBooking(bookingEntity: TiEntities.BookingEntityData,
        config?: TiInterfaces.TiMainRouteViewConfig) {
        this.setData(bookingEntity.newMainRouteSlot, bookingEntity.routeSectionSlots, config)
    }
    setData(
        mainRouteSlotEntity: TiEntities.MainRouteTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension,
        sections?: Array<TiEntities.SectionTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension>,
        config?: TiInterfaces.TiMainRouteViewConfig
    ) {

        if (config) this.setConfig(config);

        if (!mainRouteSlotEntity) return;

        this.mainRouteSlot = mainRouteSlotEntity;

        if (!sections) {
            sections = [];
            for (let ass of mainRouteSlotEntity.sectionSlotAssignments) {
                sections.push(ass.sectionSlot);
            }
        }

        this.routeSectionSlots = lang.clone(sections);

        this.drawData();        
    }
   

    setConfig(config: TiInterfaces.TiMainRouteViewConfig) {
        this.config = config;

        if (this.routeSectionSlots?.length) {
            this.drawData();
        }
    }

    private drawData() {
        
        let mainRouteSlot = this.mainRouteSlot;

        if (!mainRouteSlot) return;

        let targetNode = this.mainContainer;
        let highlightMode = this.config.highlightMode ? this.config.highlightMode : "";
        let highlightSectionID = this.config.highlightSectionSlotID;

        // ZEICHNEN: die Route insgesamt (Name, Teilstrecken-Slots)
        this.UiModder.domConstruct.create("h5", {
            "innerHTML": mainRouteSlot._isDummy ? this.mainRouteSlot._placeholderLabel ? this.mainRouteSlot._placeholderLabel : mainRouteSlot.mainRouteName : mainRouteSlot.mainRouteName,
            className: "title"
        }, targetNode, "only");

        let reachedHighlight = false;
        let sectionsContainer = this.UiModder.domConstruct.create("div", {
            className: "routeSectionsContainer flex_row_top " + highlightMode
        }, targetNode);

        //let container = this.createMainRouteContainer(mainRouteSlot);
        //this.UiModder.domConstruct.place(container, targetNode);

        for (let sectionSlot of this.routeSectionSlots) {

            if (sectionSlot.Classname == TiClassNames.section_main_route_timeslot || sectionSlot._isDummy == true) {

                let view = new TiRouteSectionsView();

                if (sectionSlot.ID == highlightSectionID) {
                    reachedHighlight = true;
                } else {
                    if (reachedHighlight === true) {
                        this.UiModder.domClass.add(view.domNode, "afterTarget");
                    } else {
                        this.UiModder.domClass.add(view.domNode, "beforeTarget");
                    }
                }
                if (sectionSlot._isDummy) {
                    view.setData(sectionSlot, {
                        enableBookingStatus: false,
                        highlight: sectionSlot.ID == highlightSectionID,
                        showExtendedInformation: this.config.sectionsConfig?.showExtendedInformation
                    });

                    view.placeAt(sectionsContainer);
                }
                else {
                    view.setData(sectionSlot, {
                        highlight: sectionSlot.ID == highlightSectionID,
                        enableBookingStatus: this.config.sectionsConfig?.enableBookingStatus,
                        showExtendedInformation: this.config.sectionsConfig?.showExtendedInformation
                    });

                    view.placeAt(sectionsContainer);

                    view.on("change", lang.hitch(this, this._onChange_RouteSection, sectionSlot))
                }
            }  else {
                continue;
            }
        }
    }

    private _onChange_RouteSection(sectionSlot: TiEntities.SectionTimeSlotEntity_Aliased) {
        this.emit("change", this.mainRouteSlot);
    }


    //private createMainRouteContainer(data: TransportIntermodal.MainRouteTimeSlotEntity_Aliased) {

    //    let container = this.UiModder.domConstruct.create("div", { className: "slotInfoContainer round" });

    //    this.UiModder.domClass.add(container, data.Classname);

    //    let mainRouteSlot = <TransportIntermodal.MainRouteTimeSlotEntity_Aliased>data;

    //    this.UiModder.domConstruct.create("div", { className: "title", "innerHTML": mainRouteSlot.mainRouteName }, container);
    //    this.UiModder.domConstruct.create("div", { className: "description", "innerHTML": mainRouteSlot.name }, container);

    //    return container;
    //}


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.config = {
            sectionsConfig: {
                highlight: false,
                enableBookingStatus: false
            },
            highlightMode: "fadeAfterTarget"
        };
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TiMainRouteView);